import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const Emmet = () =>{
function calcHeight(nbLine){
let calc = 19*nbLine
return calc+"px"
}

    return(
    
        <div id="articleContent" className="emmet">
            <h2>Raccourcis Emmet HTML </h2>
            <div>
            <p>Exemple de raccourci Emmet <br/>
            
            <strong className="highlight">{'div#MonID>(ul>li*5{item n°$})+div.maClass'}</strong>
            </p>
            <pre>
                <code>
                <AceEditor
width="100%"
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<div id="MonID">
    <ul>
        <li>item n°1</li>
        <li>item n°2</li>
        <li>item n°3</li>
        <li>item n°4</li>
        <li>item n°5</li>
    </ul>
    <div className="maClass"></div>
</div>`}
                    height={calcHeight(10)}
                  />
                </code>
                </pre>
                </div>


                <div>
        <p>Regrouper des élements multiples avec ()<br/>
            <strong className="highlight">{'div>(header>ul>li*2a)+footer>p'}</strong>
            
        </p>
<pre>
    <code>
    <AceEditor
width="100%"
    fontSize={16}
    showPrintMargin={false}
    showGutter= {true}
        mode="html"
        theme="monokai"
        value={`<div>
    <header>
        <ul>
            <li></li>
            <li></li>
            <a href=""></a>
        </ul>
    </header>
    <footer>
        <p></p>
    </footer>
</div>`}
height={calcHeight(12)}
      />
    </code>
    </pre>
    </div>


    <div>
        <p>Remonter d'un élement enfant avec ^<br/>
            <strong className="highlight">{'div>p>em{hello}^a'}</strong>
        </p>
        <pre>
    <code>
    <AceEditor
width="100%"
    fontSize={16}
    showPrintMargin={false}
    showGutter= {true}
        mode="html"
        theme="monokai"
        value={`<div>
    <p>
        <em>hello</em>
    </p>
    <a href=""></a>
</div>`}
height={calcHeight(6)}
      />
    </code>
    </pre>
    </div>


    <div className="pageBreak"></div>
    <div>
    <p>Numérotation commençant par 5<br/>
        <strong className="highlight">{'ul>li.item$@5*3'}</strong>
    </p>
    <pre>
            <code>
                <AceEditor
width="100%"
                fontSize={16}
                showPrintMargin={false}
                showGutter= {true}
                mode="html"
                theme="monokai"
                value={`<ul>
    <li className="item5"></li>
    <li className="item6"></li>
    <li className="item7"></li>
</ul>`}
height={calcHeight(5)}
              />
            </code>
            </pre>
</div>


<div>
        <p>Ajouter un attribut<br/>
            <strong className="highlight">{'img[alt="blabla"]'}</strong>
        </p>
        <pre>
                <code>
                <AceEditor
width="100%"
                    fontSize={16}
                    showPrintMargin={false}
                    showGutter= {true}
                    mode="html"
                    theme="monokai"
                    value={`<img src="" alt="blabla">`}
                    height={calcHeight(1)}
                  />
                </code>
                </pre>
    </div>


 <h2>Raccourcis Emmet CSS</h2>
    <table>
        <tr>
            <td>w100</td>
            <td>width: 100px;</td>
        </tr>
        <tr>
            <td>h25.5p</td>
            <td>height: 25.5%;</td>
        </tr>
        <tr>
            <td>m55p</td>
            <td>margin: 55%;</td>
        </tr>
        <tr>
            <td>mt50p</td>
            <td>margin-top: 50%;</td>
        </tr>
        <tr>
            <td>mr50p</td>
            <td>margin-right: 50%;</td>
        </tr>
        <tr>
            <td>mr50</td>
            <td>margin-right: 50px;</td>
        </tr>
        <tr>
            <td>pb40</td>
            <td>padding-bottom: 40px;</td>
        </tr>
        <tr>
            <td>pl43p</td>
            <td>padding-left: 43%;</td>
        </tr>
        <tr>
            <td>bg</td>
            <td>background: #000;</td>
        </tr>
        <tr>
            <td>bgi</td>
            <td>background-image: url();</td>
        </tr>
        <tr>
            <td>c</td>
            <td>color: #000</td>
        </tr>
        <tr>
            <td>f</td>
            <td>font: ;</td>
        </tr>
        <tr>
            <td>ff</td>
            <td>font-family: ;</td>
        </tr>
        <tr>
            <td>bd</td>
            <td>border: ;</td>
        </tr>
    </table>


      </div>
    )
}
